export enum PetStatus {
    Active = 1,
    Deceased = 2,
    Unknown = 3,
    Memorialized = 4,
}
